import { type FC, Suspense, lazy } from "react";
import { TextButton } from "@root/shared/components/TextButton";
import { ModalContents } from "@clientFrontend/features/publication/components/UserInformationModal/uiParts/ModalContents";
import { Loading } from "@clientFrontend/features/scout/components/Loading";
import { retryLazyLoad } from "@root/shared/utils/retryLazyLoad";
import * as styles from "./styles.css";

const Modal = lazy(() =>
  retryLazyLoad({
    fn: () => import("@root/shared/components/Modal"),
  }),
);

type Props = {
  contentName: string;
  content: string;
  isShowContent: boolean;
  isModalOpen: boolean;
  openModal: () => void;
  closeModal: () => void;
  isShowTelLink: boolean;
  name: string;
  handleClickMessageButton: () => void;
  isSP: boolean;
};

export const Presentation: FC<Props> = ({
  contentName,
  content,
  isShowContent,
  isModalOpen,
  openModal,
  closeModal,
  isShowTelLink,
  name,
  handleClickMessageButton,
  isSP,
}) => {
  return (
    <>
      {isShowContent ? (
        <p className={styles.text}>
          <span className={styles.contentText}>{contentName}：</span>
          {content}
        </p>
      ) : (
        <TextButton
          onClick={openModal}
          rightIconName="arrow-light-right"
          className={styles.textButton}
          size="small"
        >
          {contentName}を見る
        </TextButton>
      )}
      <Suspense fallback={<div>Loading...</div>}>
        <Modal
          isShow={isModalOpen}
          onClose={closeModal}
          pcWidthType="small"
          headerTitle={contentName}
          spAppearanceType="bottom"
        >
          {isShowContent ? (
            <ModalContents
              content={content}
              contentName={contentName}
              name={name}
              handleClickMessageButton={handleClickMessageButton}
              isShowTelLink={isShowTelLink}
              isSP={isSP}
            />
          ) : (
            <Loading isShadow={false} />
          )}
        </Modal>
      </Suspense>
    </>
  );
};
